import { Drawer as DrawerPrimitive } from 'vaul';

export const DrawerClose = DrawerPrimitive.Close;
